// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Tooltip_tooltip__jL3d7","tooltipContent":"Tooltip_tooltipContent__RPSnq","triangle":"Tooltip_triangle__1-wqw","tooltipHeader":"Tooltip_tooltipHeader__1UdIG"};